import { Helmet } from 'react-helmet-async';
import PriceAccountsView from '../../../components/dashboard/admin/price-accounts/PriceAccountsView';

export default function PriceAccounts() {

  return (
    <>
      <Helmet>
        <title>Admin Price Accounts | Platform Solutions</title>
      </Helmet>

      <PriceAccountsView />
    </>
  );
}
